let membersGateCleanup = null;

function escapeHtml(value) {
  return String(value)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}

function escapeMultilineHtml(value) {
  return escapeHtml(value).replace(/\n/g, "<br>");
}

function openPendingLink(link) {
  if (!(link instanceof HTMLAnchorElement)) return;

  const href = link.getAttribute("href");
  if (!href) return;

  if (link.target === "_blank") {
    window.open(href, "_blank", "noopener");
    return;
  }

  if (window.swup && typeof window.swup.navigate === "function") {
    window.swup.navigate(href);
    return;
  }

  window.location.assign(href);
}

function buildModalContent(copy) {
  return `
    <div class="c-members-gate">
      <h2 id="overlay-modal-title" class="c-members-gate__title t-xl">${escapeHtml(copy.title)}</h2>
      <p class="c-members-gate__text t-text">${escapeMultilineHtml(copy.text)}</p>
      <form class="c-members-gate__form" novalidate>
        <label class="u-visually-hidden" for="members-gate-password">${escapeHtml(
          copy.passwordLabel
        )}</label>
        <input
          id="members-gate-password"
          class="c-members-gate__input"
          type="password"
          name="password"
          autocomplete="current-password"
          placeholder="${escapeHtml(copy.passwordLabel)}"
          required
        />
        <p class="c-members-gate__password-help t-s">${copy.passwordHelpHtml}</p>
        <p class="c-members-gate__error t-s" role="alert" aria-live="polite"></p>
        <div class="c-members-gate__actions">
          <button class="c-btn" type="submit">${escapeHtml(copy.submitLabel)}</button>
        </div>
      </form>
    </div>
  `;
}

export function initMembersOnlyGate() {
  if (typeof membersGateCleanup === "function") {
    membersGateCleanup();
    membersGateCleanup = null;
  }

  const grid = document.querySelector(".c-resource-grid[data-members-password]");
  if (!(grid instanceof HTMLElement)) return;

  const hasProtectedLinks = grid.querySelector("a[data-members-only='true']");
  if (!hasProtectedLinks) return;

  const modal = document.querySelector(".c-overlay-modal");
  const modalContent = modal?.querySelector(".c-overlay-modal__content");
  const modalBackdrop = modal?.querySelector(".c-overlay-modal__backdrop");
  if (!(modal instanceof HTMLElement) || !(modalContent instanceof HTMLElement)) return;

  const sessionKey =
    grid.getAttribute("data-members-session-key") || "resources-members-access";
  const configuredPassword = (grid.getAttribute("data-members-password") || "").trim();
  const modalCopy = {
    title:
      (grid.getAttribute("data-members-title") || "").trim() || "Members-only resource",
    text:
      (grid.getAttribute("data-members-text") || "").trim() ||
      "Enter the members password to continue.",
    passwordHelpHtml: (grid.getAttribute("data-members-password-help-html") || "").trim(),
    passwordLabel: "Password",
    submitLabel: "Unlock",
  };

  const isAccessGranted = () => {
    return sessionStorage.getItem(sessionKey) === "1";
  };

  const setAccessGranted = () => {
    sessionStorage.setItem(sessionKey, "1");
  };

  let pendingLink = null;

  const closeModal = () => {
    modal.hidden = true;
    modal.setAttribute("aria-hidden", "true");
    modalContent.innerHTML = "";
    document.body.classList.remove("is-modal-open");
  };

  const handleEscape = (event) => {
    if (event.key !== "Escape") return;
    closeModal();
  };

  const openModal = () => {
    modalContent.innerHTML = buildModalContent(modalCopy);
    modal.hidden = false;
    modal.setAttribute("aria-hidden", "false");
    document.body.classList.add("is-modal-open");

    const form = modalContent.querySelector(".c-members-gate__form");
    const input = modalContent.querySelector(".c-members-gate__input");
    const error = modalContent.querySelector(".c-members-gate__error");
    if (!(form instanceof HTMLFormElement) || !(input instanceof HTMLInputElement)) return;

    requestAnimationFrame(() => input.focus());

    form.addEventListener("submit", (event) => {
      event.preventDefault();

      const value = input.value.trim();
      if (!configuredPassword || value === configuredPassword) {
        setAccessGranted();
        closeModal();
        openPendingLink(pendingLink);
        pendingLink = null;
        return;
      }

      if (error instanceof HTMLElement) {
        error.textContent = "Incorrect password. Try again.";
      }
      input.select();
    });
  };

  const handleLinkClickCapture = (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;

    const link = target.closest("a[data-members-only='true']");
    if (!(link instanceof HTMLAnchorElement)) return;
    if (!configuredPassword) return;
    if (isAccessGranted()) return;

    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === "function") {
      event.stopImmediatePropagation();
    }
    pendingLink = link;
    openModal();
  };

  const handleBackdropClick = () => closeModal();

  document.addEventListener("click", handleLinkClickCapture, true);
  document.addEventListener("keydown", handleEscape);
  if (modalBackdrop instanceof HTMLElement) {
    modalBackdrop.addEventListener("click", handleBackdropClick);
  }

  membersGateCleanup = () => {
    document.removeEventListener("click", handleLinkClickCapture, true);
    document.removeEventListener("keydown", handleEscape);
    if (modalBackdrop instanceof HTMLElement) {
      modalBackdrop.removeEventListener("click", handleBackdropClick);
    }
    if (!modal.hidden) closeModal();
  };
}
